import React from "react";

export default function Twitter() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M30.5916 14.5685C30.6086 14.8054 30.6086 15.0423 30.6086 15.2792C30.6086 22.5042 25.1094 30.8292 15.0586 30.8292C11.9621 30.8292 9.08566 29.9323 6.66602 28.3757C7.10597 28.4264 7.52894 28.4434 7.98581 28.4434C10.5408 28.4434 12.8928 27.5804 14.7709 26.1084C12.3682 26.0576 10.3547 24.484 9.66092 22.3181C9.99936 22.3689 10.3377 22.4027 10.6931 22.4027C11.1838 22.4027 11.6745 22.335 12.1313 22.2166C9.62712 21.709 7.74888 19.5093 7.74888 16.8528V16.7851C8.47644 17.1912 9.32254 17.445 10.2193 17.4788C8.74717 16.4974 7.78274 14.8223 7.78274 12.9272C7.78274 11.912 8.05342 10.9814 8.52722 10.1692C11.2176 13.4856 15.2616 15.6514 19.7963 15.8883C19.7117 15.4822 19.6609 15.0593 19.6609 14.6362C19.6609 11.6243 22.0975 9.1709 25.1262 9.1709C26.6998 9.1709 28.1212 9.8308 29.1195 10.8968C30.3547 10.6599 31.5391 10.203 32.5882 9.57699C32.1821 10.8461 31.3191 11.9121 30.1855 12.5888C31.2853 12.4704 32.3513 12.1658 33.3327 11.7428C32.5883 12.8257 31.6576 13.7901 30.5916 14.5685Z"
        fill="#1DA1F2"
      />
    </svg>
  );
}
